export const IGNORED_SIGNS_KEYS = [
  'onboarding.landingWellness.ignoredSigns.chronicInflammation',
  'onboarding.landingWellness.ignoredSigns.weakenedImmunity',
  'onboarding.landingWellness.ignoredSigns.organStress',
  'onboarding.landingWellness.ignoredSigns.mentalFog',
] as const
